// extracted by mini-css-extract-plugin
export default {"notifications":"GEdzYG9RTHVFvs_iS_LX","allButton":"CcOTkSiZp4BaVmFfOsRX","divider":"aFhERgGQXn2gXalnRnVJ"};